/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useCallback } from "react";
import MetaTags from "react-meta-tags";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Row,
} from "reactstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import Select from "react-select";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import SignatureModal from "../../components/SignatureModal";

import {
  postContactsCreate,
  postContactsSame,
  postContactsVincular,
} from "../../helpers/backend";
import ButtonVolver from "../../components/ButtonVolver";
import { useSelector } from "react-redux";
import CountryStateCitySelect from "../../components/CountryStateCitySelect";

// Constantes
const IDENTIFICATION_TYPES = [
  { label: "DNI", value: "DNI" },
  { label: "Pasaporte", value: "PASAPORTE" },
  { label: "NIE", value: "NIE" },
  { label: "CIF", value: "CIF" },
];

const GENDER_OPTIONS = [
  { label: "Masculino", value: "Masculino" },
  { label: "Femenino", value: "Femenino" },
  { label: "Otro", value: "Otro" },
];

const ContactsCreate = () => {
  const history = useHistory();
  const [errorPhone, setErrorPhone] = useState(false);
  const [showReplaceAlert, setShowReplaceAlert] = useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [existingContact, setExistingContact] = useState(null);
  const [showGenericError, setShowGenericError] = useState(false);
  const [formData, setFormData] = useState({
    username: "",
    first_name: "",
    last_name: "",
    documentNumber: "",
    birthdate: "2000-01-01",
    city: "",
    country: "",
    zip_code: "",
    state: "",
    address: "",
    gender: "Otro",
    contactType: "PERSONA NATURAL",
    documentType: "",
    phone: "",
    contacts: "",
    parentesco: "",
    createUser: false,
    password: "",
    confirm_password: "",
    codigoCAUAGENT: "",
    codigo_visitador: "",
    cargo: "",
    firma: null
  });

  const [showSignatureModal, setShowSignatureModal] = useState(false);
  const [signatureFile, setSignatureFile] = useState(null);

  const {
    username,
    first_name,
    last_name,
    documentNumber,
    birthdate,
    gender,
    documentType,
    phone,
    password,
    confirm_password,
  } = formData;

  const onChange = useCallback(
    (e) => {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    },
    [formData]
  );

  const handleSignatureSave = useCallback((signatureFile) => {
    setSignatureFile(signatureFile);
    setFormData({ ...formData, firma: signatureFile });
    setShowSignatureModal(false);
    toast.success("Firma guardada exitosamente");
  }, [formData]);

  const handleRemoveSignature = useCallback(() => {
    setSignatureFile(null);
    setFormData({ ...formData, firma: null });
    toast.info("Firma eliminada");
  }, [formData]);

  const handleLocationChange = (location) => {
    // console.log('Location selected:', location);
    
    setFormData({
      ...formData,
      country: location.country,
      state: location.state,
      city: location.city,
    });
  };

  const onSubmit = useCallback(
    async (e) => {
      e.preventDefault();

      if (!formData.phone) {
        setErrorPhone(true);
        return;
      }

      // Filtrar datos antes de enviar
      const dataToSend = {
        ...formData,
      };
      if (!dataToSend.createUser) {
        delete dataToSend.password;
        delete dataToSend.confirm_password;
      }

      const response = await postContactsCreate(dataToSend);
      console.log(response);

      if (response.status === 200 || response.status === 201) {
        setShowSuccessAlert(true); // Mostrar SweetAlert de éxito
      } else if (response?.status === 400) {
        setExistingContact(response.data); // Corregido: usar `response` en lugar de `error`
        setShowReplaceAlert(true);
      } else {
        console.error("Error inesperado:", response);
        setShowGenericError(true);
      }
    },
    [formData]
  );

  const onCheckboxChange = useCallback(
    (e) => {
      setFormData({ ...formData, createUser: e.target.checked });
    },
    [formData]
  );

  const redirect = useCallback(() => {
    history.goBack();
  }, [history]);

  const theme = useSelector((state) => state.theme.theme) || "light";
  

  const handleReplaceContact = useCallback(async () => {
    const { documentNumber, ...restFormData } = formData; // Excluir documentNumber
    try {
      const response = await postContactsVincular({
        ...restFormData,
        contact_id: existingContact.contact_id,
      });
      console.log(response);
      setShowReplaceAlert(false);
      setShowSuccessAlert(true); // Mostrar SweetAlert de éxito después de reemplazar
    } catch (error) {
      console.error("Error al reemplazar contacto:", error);
    }
  }, [formData, existingContact]);

  const handleCreateNewContact = useCallback(async () => {
    const { documentNumber, ...restFormData } = formData; // Excluir documentNumber
    const response = await postContactsSame(restFormData);
    console.log(response);

    if (response.status === 200 || response.status === 201) {
      setShowReplaceAlert(false);
      setShowSuccessAlert(true);
    } else if (response?.status === 400) {
      setExistingContact(response.detail); // Corregido: usar `response` en lugar de `error`
    } else {
      console.error("Error inesperado:", response);
      setShowGenericError(true);
    }
  }, [formData]);

  const renderInputField = useCallback(
    (id, label, type, value, error, required = true) => (
      <Col lg={6} className="mb-3">
        <Label style={{color: theme === 'dark' && "#c3cbe4"}} for={id} className="form-label">
          {label}
        </Label>
        <Input
          id={id}
          name={id}
          type={type}
          onChange={onChange}
          value={value}
          valid={error ? true : false}
          invalid={error ? true : false}
          required={required}
        />
        <FormFeedback>{error}</FormFeedback>
      </Col>
    ),
    [onChange]
  );

  const renderSelectField = useCallback(
    (id, label, options, value, onChange) => (
      <Col lg={6} className="mb-3">
        <Label
          style={{ color: theme === "dark" && "#c3cbe4" }}
          for={id}
          className="form-label"
        >
          {label}
        </Label>
        <Select
          id={id}
          name={id}
          onChange={(item) => onChange(item.value)}
          options={options}
          placeholder={"Seleccione"}
          value={options.find((option) => option.value === value)}
          styles={{
            control: (base) => ({
              ...base,
              backgroundColor: theme === "dark" ? "#2c2c2c" : "#fff",
              color: theme === "dark" ? "#c3cbe4" : "#000",
              borderColor: theme === "dark" ? "#3b3b3b" : "#d2d2d2",
              cursor: "pointer",
              fontSize: "0.9rem",
            }),
            menu: (base) => ({
              ...base,
              backgroundColor: theme === "dark" ? "#242424" : "#fff",
              borderRadius: "8px",
              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
            }),
            option: (base, { isFocused, isSelected }) => ({
              ...base,
              backgroundColor: isSelected
                ? theme === "dark"
                  ? "#242424"
                  : "#ccc"
                : isFocused
                ? theme === "dark"
                  ? "#121212"
                  : "#ddd"
                : "transparent",
              color: theme === "dark" ? "#c3cbe4" : "#000",
              padding: "10px",
              fontSize: "0.9rem",
              cursor: "pointer",
            }),
            singleValue: (base) => ({
              ...base,
              color: theme === "dark" ? "#c3cbe4" : "#000",
            }),
          }}
        />
      </Col>
    ),
    []
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Cuidad Limpia | Contactos</title>
        </MetaTags>
        <Container fluid>
          <Col className="d-flex gap-3 mb-4 align-items-center">
            <ButtonVolver />
            <span style={{ fontSize: "1.2rem", fontWeight: "600" }}>
              Contactos
            </span>
          </Col>
          <Card className="col-lg-8 mx-auto mt-3">
            {showSuccessAlert && (
              <SweetAlert
                success
                title="¡Hecho!"
                onConfirm={() => {
                  setShowSuccessAlert(false);
                  redirect();
                }}
              >
                Se ha agregado el contacto con éxito.
              </SweetAlert>
            )}
            {showReplaceAlert && (
              <SweetAlert
                warning
                showCancel
                confirmBtnText="Reemplazar"
                cancelBtnText="Crear uno nuevo"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="primary"
                title="El Contacto ya existe"
                onConfirm={handleReplaceContact}
                onCancel={handleCreateNewContact}
              >
                ¿Deseas reemplazar el contacto existente o crear uno nuevo?
              </SweetAlert>
            )}
            {showGenericError && (
              <SweetAlert
                danger
                title="Error"
                onConfirm={() => setShowGenericError(false)}
              >
                Ocurrió un error al crear el contacto. Verifica los datos
                ingresados.
              </SweetAlert>
            )}
            <CardBody>
              <h4 className="card-title">Crear Nuevo Contacto</h4>
              <Form
                className="form-control needs-validation"
                onSubmit={onSubmit}
                style={{ border: "none" }}
              >
                <Row>
                  {renderInputField(
                    "first_name",
                    "Nombres",
                    "text",
                    first_name
                  )}
                  {renderInputField(
                    "last_name",
                    "Apellidos",
                    "text",
                    last_name
                  )}
                </Row>
                <Row>
                  {renderInputField(
                    "username",
                    "Correo Electrónico",
                    "text",
                    username
                  )}
                  {renderSelectField(
                    "documentType",
                    "Tipo de identificación",
                    IDENTIFICATION_TYPES,
                    documentType,
                    (value) => setFormData({ ...formData, documentType: value })
                  )}
                </Row>
                <Row>
                  {renderInputField(
                    "documentNumber",
                    "Documento",
                    "number",
                    documentNumber
                  )}
                  {renderSelectField(
                    "gender",
                    "Género",
                    GENDER_OPTIONS,
                    gender,
                    (value) => setFormData({ ...formData, gender: value })
                  )}
                </Row>
                <Row>
                  {renderInputField(
                    "birthdate",
                    "Fecha de Nacimiento",
                    "date",
                    birthdate,
                    false
                  )}
                  <Col lg={6} className="mb-3">
                    <Label
                      style={{ color: theme === "dark" && "#c3cbe4" }}
                      for="phone"
                      className="form-label"
                    >
                      Teléfono
                    </Label>
                    <PhoneInput
                      id="phone"
                      name="phone"
                      inputProps={{ name: "phone", required: true }}
                      country={"co"}
                      value={phone}
                      isValid={(value) => {
                        if (!value) return "Este campo es requerido";
                        return true;
                      }}
                      onChange={(item) => {
                        setFormData({ ...formData, phone: item });
                        setErrorPhone(false);
                      }}
                    />
                    {errorPhone && (
                      <p className="font-size-12 text-danger">
                        Este campo es requerido
                      </p>
                    )}
                  </Col>
                </Row>
                <Row>
                  <Col lg={6} className="mb-3">
                    <Label
                      style={{ color: theme === "dark" && "#c3cbe4" }}
                      for="phone"
                      className="form-label"
                    >
                      Dirección
                    </Label>
                    <CountryStateCitySelect
                      onLocationChange={handleLocationChange}
                    />
                  </Col>
                  <Col lg={6} className="mb-3">
                    <div>
                      <Label
                        style={{ color: theme === "dark" && "#c3cbe4" }}
                        for="zip_code"
                        className="form-label"
                      >
                        Código Postal
                      </Label>
                      <Input
                        id="zip_code"
                        name="zip_code"
                        type="text"
                        onChange={onChange}
                        value={formData.zip_code}
                      />
                      <Label
                        style={{ color: theme === "dark" && "#c3cbe4" }}
                        for="contacts"
                        className="form-label mt-2"
                      >
                        Address
                      </Label>
                      <Input
                        id="address"
                        name="address"
                        type="text"
                        onChange={onChange}
                        value={formData.address}
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  {renderInputField(
                    "codigoCAUAGENT",
                    "Código CAU Agent",
                    "text",
                    formData.codigoCAUAGENT,
                    null,
                    false
                  )}
                  {renderInputField(
                    "codigo_visitador",
                    "Código Visitador",
                    "text",
                    formData.codigo_visitador,
                    null,
                    false
                  )}
                </Row>

                <Row>
                  {renderInputField(
                    "cargo",
                    "Cargo",
                    "text",
                    formData.cargo,
                    null,
                    false
                  )}
                  <Col lg={6} className="mb-3">
                    <Label
                      style={{ color: theme === "dark" && "#c3cbe4" }}
                      className="form-label"
                    >
                      Firma Digital
                    </Label>
                    <div className="d-flex align-items-center gap-2">
                      <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        onClick={() => setShowSignatureModal(true)}
                      >
                        <i className="mdi mdi-pen me-1"></i>
                        {signatureFile ? 'Editar Firma' : 'Agregar Firma'}
                      </button>
                      {signatureFile && (
                        <>
                          <span className="text-success small">
                            <i className="mdi mdi-check-circle me-1"></i>
                            Firma guardada
                          </span>
                          <button
                            type="button"
                            className="btn btn-outline-danger btn-sm"
                            onClick={handleRemoveSignature}
                          >
                            <i className="mdi mdi-delete"></i>
                          </button>
                        </>
                      )}
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col lg={6} className="mb-3">
                    <Label
                      style={{ color: theme === "dark" && "#c3cbe4" }}
                      for="createUser"
                      className="form-label"
                    >
                      <Input
                        id="createUser"
                        name="createUser"
                        type="checkbox"
                        onChange={onCheckboxChange}
                        checked={formData.createUser}
                      />{" "}
                      Crear Usuario
                    </Label>
                  </Col>
                </Row>
                {formData.createUser && (
                  <>
                    {renderInputField(
                      "password",
                      "Contraseña",
                      "password",
                      password,
                      password !== confirm_password
                        ? "Las contraseñas no coinciden"
                        : ""
                    )}
                    {renderInputField(
                      "confirm_password",
                      "Confirmar Contraseña",
                      "password",
                      confirm_password,
                      password !== confirm_password
                        ? "Las contraseñas no coinciden"
                        : ""
                    )}
                  </>
                )}
                <Row className="col-lg-12 justify-content-center mt-3">
                  <Col md={4} className="ms-5 d-flex justify-content-center">
                    <Link
                      className="btn btn-secondary text-black"
                      to="/contacts"
                    >
                      Volver
                    </Link>
                    <Button color="primary" type="submit" className="ms-1">
                      Enviar
                    </Button>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>
        </Container>
      </div>
      
      <SignatureModal
        isOpen={showSignatureModal}
        onHide={() => setShowSignatureModal(false)}
        onSave={handleSignatureSave}
        title="Firma Digital del Contacto"
      />
    </React.Fragment>
  );
};

export default ContactsCreate;
